import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const footerRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [hoverIcon, setHoverIcon] = useState(null);
  const [hoverButton, setHoverButton] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.3 }
    );
    if (footerRef.current) observer.observe(footerRef.current);
    return () => observer.disconnect();
  }, []);

  const handleNavigateLetsConnect = () => {
    navigate("/lets-connect");
  };

  return (
    <footer
      className={`footer-container ${visible ? "footer-visible" : ""}`}
      ref={footerRef}
    >
      <div className="footer-top-section">
        <h2 className="footer-title">Elevate Your Influence with ZZAYRAAT!</h2>
        <p className="footer-subtitle">Explore, Collaborate, Innovate and Achieve</p>
        <button
          className={`footer-collaborate-btn ${hoverButton ? "btn-hover" : ""}`}
          onMouseEnter={() => setHoverButton(true)}
          onMouseLeave={() => setHoverButton(false)}
          onClick={handleNavigateLetsConnect}
          type="button"
        >
          Let's Collaborate
        </button>
      </div>

      <div className="footer-main-content">
        {/* ---------- LEFT SECTION ---------- */}
        <div className="footer-left-section">
          {/* 1. LOGO AT THE TOP */}
          <div className="footer-logo-container">
            <img
              src="/images/image12.png"
              alt="Zzayraat Logo"
              className="footer-logo-img"
            />
          </div>
          <div className="footer-right-section">
          {/* 3. CONTACT SECTION */}
          <div className="footer-text-group">
            <p className="footer-heading">Contact Us:</p>
            <a href="mailto:zzayraat@gmail.com" className="footer-contact-link">
              zzayraat@gmail.com <br />
              <br />9156771049
              <br />9307081049
            </a>
          </div>

          {/* 4. FOLLOW US SECTION */}
          <div className="footer-text-group">
            <p className="footer-heading">Follow Us On</p>
            <div className="footer-social-icons">
              <a
                href="https://www.instagram.com/zzayraat?"
                target="_blank"
                rel="noopener noreferrer"
                className={`footer-social-icon ${hoverIcon === "instagram" ? "social-icon-hover" : ""}`}
                onMouseEnter={() => setHoverIcon("instagram")}
                onMouseLeave={() => setHoverIcon(null)}
                aria-label="Instagram"
              >
                <i className="fa-brands fa-instagram"></i>
              </a>
              <a
                href="https://www.facebook.com/share/1GAjKczCe7/Zzayraat "
                target="_blank"
                rel="noopener noreferrer"
                className={`footer-social-icon ${hoverIcon === "facebook" ? "social-icon-hover" : ""}`}
                onMouseEnter={() => setHoverIcon("facebook")}
                onMouseLeave={() => setHoverIcon(null)}
                aria-label="Facebook"
              >
                <i className="fa-brands fa-facebook-f"></i>
              </a>
              <a
  href="https://www.youtube.com/@Zzayraat
"
  target="_blank"
  rel="noopener noreferrer"
  className={`footer-social-icon ${hoverIcon === "youtube" ? "social-icon-hover" : ""}`}
  onMouseEnter={() => setHoverIcon("youtube")}
  onMouseLeave={() => setHoverIcon(null)}
  aria-label="YouTube"
>
  <i className="fa-brands fa-youtube"></i>
</a>

              <a
                href="https://www.linkedin.com/company/zzayraat/"
                target="_blank"
                rel="noopener noreferrer"
                className={`footer-social-icon ${hoverIcon === "linkedin" ? "social-icon-hover" : ""}`}
                onMouseEnter={() => setHoverIcon("linkedin")}
                onMouseLeave={() => setHoverIcon(null)}
                aria-label="LinkedIn"
              >
                in
              </a>
            </div>
          </div>
        </div>

          {/* 2. WORK WITH US SECTION */}
         
        </div>

        {/* ---------- RIGHT SECTION ---------- */}
         <div className="footer-text-group">
            <p className="footer-heading">Work with Us</p>
            <p className="footer-address-text">Be a part of the team</p>
            <p className="footer-address-text">
              47/2 Chatrapati Shivaji Nagar, Hupari - 416203 ,

              <br />
               Kolhapur 416203
            </p>
          </div>
      </div>

      <div className="footer-copyright">
        <p>© 2026 Zzayrat. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;